import script from "./SurgeError.vue?vue&type=script&setup=true&lang=js"
export * from "./SurgeError.vue?vue&type=script&setup=true&lang=js"

import "./SurgeError.vue?vue&type=style&index=0&id=6c4e9024&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4e9024"]])

export default __exports__